import { PipelineErrorsInterface } from 'modules/crm/pipeline/type/pipeline-errors-interface'

export const defaultErrors: PipelineErrorsInterface = {
  fields: { name: '' },
  common: [],
}
